import Avatar from '@/app/components/ui/Avatar';
import Pill from '@/app/components/ui/Pill';
import type { QueryFieldOption } from './types';

export const contactOptionItem = (option: QueryFieldOption) => (
  <div className="flex min-w-0 items-center gap-2">
    <Avatar
      size={20}
      name={option.label}
      src={option.meta?.photoUrl as string | undefined}
      isExternalUrl
      initialsClassName="!text-[9px] leading-none"
    />
    <span className="min-w-0 truncate">{option.label}</span>
  </div>
);

export const contactTagItem = (option: QueryFieldOption) => (
  <Pill
    variant="soft"
    color="neutral"
    rounded={false}
    className="w-fit max-w-full shrink-0 !justify-start gap-1.5 overflow-hidden normal-case"
  >
    <Avatar
      size={12}
      name={option.label}
      src={option.meta?.photoUrl as string | undefined}
      isExternalUrl
      initialsClassName="!text-[6px] leading-none"
    />
    <span className="min-w-0 truncate">{option.label}</span>
  </Pill>
);
